import { GamePayTableProperties } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/properties/GamePayTableProperties";
import { GameStyle } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/style/GameStyle";
import { SlingoStyle } from "@lib/titan2-slingo/dist/game/view/abstract/style/SlingoStyle";
import { SpineProperties } from "@lib/titan2/dist/game/control/properties/SpineProperties";
import { Circle, Point } from "pixi.js";
import { getLandscapeCells } from "../landscape/PayTableLandscapeProperties";
/**
 * PayTablePortraitProperties.ts
 */
export class PayTablePortraitProperties extends GamePayTableProperties {
    constructor() {
        super();
        this.animationProperties = new SpineProperties(GameStyle.PAY_LADDER, SlingoStyle.MODULE, new Point(512, 742), new Point(1.5, 1.5));
        this.cells = getLandscapeCells();
        this.landscapePrimary = true;
        this.backToGameButtonProperties.position.set(378, 1590);
        this.backToGameButtonProperties.hitArea = new Circle(150, 145, 130);
    }
}
//# sourceMappingURL=PayTablePortraitProperties.js.map